import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import ProgramCarouselSection from '../../../../shared/ProgramCarouselSection/ProgramCarouselSection';
import type { ProgramItem } from '../../../../shared/ProgramCarouselSection/ProgramCarouselSection.types';

import {
  getLatestUpdatedPrograms,
  normalizeLatestUpdatedPrograms,
} from '../../../../../services/api/contentLatestUpdatedPrograms';
import { selectBlockData } from '../../../../Blocks/ssrData';

const PROGRAMS_PATH = '/programas';
const PROGRAMS_LIMIT = 8;

export default function ProgramViewProgramsCarousel() {
  const preloadedData = useSelector((state: any) =>
    selectBlockData(state, undefined, 'programCarousel'),
  );
  const hasPreloadedData = Array.isArray(preloadedData);
  const [items, setItems] = useState<ProgramItem[]>(() =>
    normalizeLatestUpdatedPrograms(preloadedData).slice(0, PROGRAMS_LIMIT),
  );
  const [loading, setLoading] = useState<boolean>(!hasPreloadedData);

  useEffect(() => {
    if (hasPreloadedData) {
      setItems(
        normalizeLatestUpdatedPrograms(preloadedData).slice(0, PROGRAMS_LIMIT),
      );
      setLoading(false);
      return;
    }

    let isMounted = true;

    async function loadPrograms() {
      setLoading(true);

      const result = await getLatestUpdatedPrograms();

      if (isMounted) {
        setItems(result.slice(0, PROGRAMS_LIMIT));
        setLoading(false);
      }
    }

    loadPrograms();

    return () => {
      isMounted = false;
    };
  }, [hasPreloadedData, preloadedData]);

  return (
    <ProgramCarouselSection
      items={items}
      loading={loading}
      title="Programas"
      subtitle="Conheça os programas que fazem parte da nossa grade"
      href={PROGRAMS_PATH}
      actionLabel="Ver todos"
      emptyMessage={`Nenhum programa publicado encontrado em ${PROGRAMS_PATH}`}
    />
  );
}
